import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './profile.scss';
import {
   useGetUserDataQuery, useLazyGetAllUserProfilesQuery,
} from '../../../store/user/user.api';
import ProfileInfo from '../../profile/profile-info';
import { IS_ADMIN } from '../../../utils/role';
import ProfileUsers from '../../profile/profile-users';
import { isAzureIDP, isKeycloakIDP } from '../../../utils/loginProvider';
import { Button } from 'react-bootstrap';
import logoutIcon from '../../../assets/icons/box-right-arrow.svg';
import { useMsal } from '@azure/msal-react';
import { useKeycloak } from '@react-keycloak/web';
import { clearAccessTokenLocalStorage } from '../../../utils/token';

const Profile = () => {
   const [translate] = useTranslation(['common']);
   const { data: userData } = useGetUserDataQuery();
   const [trigger, { data: users }] = useLazyGetAllUserProfilesQuery();
   const { instance } = useMsal();

   const useConditionalKeycloak = () => isKeycloakIDP ? useKeycloak() : null;
   
   const keycloakContext = useConditionalKeycloak();
   const keycloak = keycloakContext ? keycloakContext.keycloak : null;
   

   const logoutFromApp = () => isAzureIDP ? azureLogout() : keycloakLogout();
   

   const azureLogout = () => {
      const logoutRequest = {
         postLogoutRedirectUri: '/',
         mainWindowRedirectUri: '/',
      };
      clearAccessTokenLocalStorage();
      instance.logoutRedirect(logoutRequest);
   }

   const keycloakLogout = () => {
      clearAccessTokenLocalStorage();
      keycloak && keycloak.logout();
   };

   const isAdmin = IS_ADMIN();

   useEffect(() => {
      isAdmin && trigger();
   }, [isAdmin]);

   return (
      <main className='app-page profile-page'>
         <div className='header profile-page-header'>
            <h1 className='title'>My {translate('common:profile.profile')}</h1>
            <Button onClick={logoutFromApp} className='primary' >
               Log Out <img src={logoutIcon} width={15} height={15} alt='' aria-hidden='true' />
            </Button>
         </div>
         <div className='profile-grid'>
            {userData && <ProfileInfo userData={userData}></ProfileInfo>}
            {isAdmin && users && <ProfileUsers users={users} currentUser={userData} />}
         </div>
      </main>
   );
};

export default Profile;
